<template>
  <v-card>
    <v-card-text>
      <v-container fluid class="pa-2">
        <!-- Organizational Data -->
        <v-row align="center">
          <v-col>
            <h4>Organizational data</h4>
            <p>Enable organizational data tracking for this location.</p>
          </v-col>
          <v-col cols="auto">
            <v-checkbox
              v-model="registerSettings.metadata.organizationalData"
            />
          </v-col>
        </v-row>

        <!-- Shift System -->
        <v-row align="center">
          <v-col>
            <h4>Shift System</h4>
            <p>
              Allows you to open and close the till on a cash drawer. Invoices
              will not be allowed unless the shift/till is open. At the end of
              each shift the option to count the cash in the drawer is given.
              You can set up the minimum cash the shift should open with inside
              the register settings on the terminal.
            </p>
          </v-col>
          <v-col cols="auto">
            <v-checkbox v-model="registerSettings.shiftEnabled" />
          </v-col>
        </v-row>

        <!-- Location Data Reset -->
        <v-row>
          <v-col>
            <h4>Location Data Reset</h4>
            <p>
              Start this location fresh while choosing which operational data
              to remove. You will review exact record counts and retained data
              before anything is permanently deleted.
            </p>
            <v-btn
              outlined
              color="error"
              @click="resetDialog = true"
            >
              <v-icon left small>mdi-database-refresh</v-icon>
              Reset Location Data
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>

    <!-- Footer buttons -->
    <v-card-actions class="pa-3 justify-end">
      <v-btn text color="secondary" @click="cancel"> Cancel </v-btn>
      <v-btn color="primary" dark @click="update">
        <v-icon left small>mdi-check</v-icon>
        Update
      </v-btn>
    </v-card-actions>

    <v-dialog v-model="resetDialog" max-width="760" persistent>
      <LocationResetDialog
        v-if="resetDialog"
        :LocationId="LocationId"
        :location="location"
        @close="resetDialog = false"
      />
    </v-dialog>
  </v-card>
</template>

<script>
import locationService from "../service.js";
import LocationResetDialog from "./LocationResetDialog.vue";

export default {
  name: "location-settings",
  props: ["LocationId", "location"],
  components: { LocationResetDialog },
  data() {
    return {
      registerSettings: {
        walkInCustomer: true,
        shiftEnabled: false,
        requireInventory: false,
        metadata: {
          organizationalData: false,
          closeShiftNotification: {
            enabled: false,
            emails: [],
          },
        },
      },
      resetDialog: false,
    };
  },

  created() {
    this.loadSettings();
  },

  methods: {
    // async loadSettings() {
    //   this.$Progress.start();
    //   try {
    //     const res = await locationService.Settings.Register.get(
    //       this.LocationId
    //     );
    //     const settings = res.data;

    //     console.log("res setting", settings);
    //     this.registerSettings = { ...this.registerSettings, ...settings };
    //     if (!settings.metadata?.closeShiftNotification) {
    //       this.registerSettings.metadata.closeShiftNotification = {
    //         enabled: false,
    //         emails: [],
    //       };
    //     }
    //     this.emailInfoList =
    //       this.registerSettings.metadata.closeShiftNotification.emails;
    //     this.$Progress.finish();
    //   } catch (error) {
    //     this.$Progress.fail();
    //     this.$toasted.error(error?.data?.message || error.message, {
    //       position: "top-right",
    //       icon: "error",
    //       duration: 2000,
    //     });
    //   }
    // },
    async loadSettings() {
      this.$Progress.start();
      try {
        const res = await locationService.Settings.Register.get(
          this.LocationId
        );
        const settings = res.data;

        // 🛡 Defensive defaults
        if (!settings.metadata || typeof settings.metadata !== "object") {
          settings.metadata = {};
        }
        if (!settings.metadata.closeShiftNotification) {
          settings.metadata.closeShiftNotification = {
            enabled: false,
            emails: [],
          };
        }
        if (typeof settings.metadata.organizationalData === "undefined") {
          settings.metadata.organizationalData = false;
        }

        // Merge safely
        this.registerSettings = Object.assign(
          {},
          this.registerSettings,
          settings
        );

        this.$Progress.finish();
      } catch (error) {
        this.$Progress.fail();
        this.$toasted.error(error?.data?.message || error.message, {
          position: "top-right",
          icon: "error",
          duration: 2000,
        });
      }
    },
    cancel() {
      this.loadSettings();
    },

    async update() {
      this.$Progress.start();
      try {
        await locationService.Settings.Register.update(
          this.LocationId,
          this.registerSettings
        );
        this.$emit("updated");
        this.$Progress.finish();
        this.$toasted.success("Setting was updated", {
          position: "top-right",
          icon: "check",
          duration: 2000,
        });
      } catch (error) {
        this.$Progress.fail();
        this.$toasted.error(error?.data?.message || error.message, {
          position: "top-right",
          icon: "error",
          duration: 2000,
        });
      }
    },
  },
};
</script>
